import React, { useState, useEffect }  from 'react';
import { Grid, TextField, Tooltip, IconButton, Link, FormControl } from '@mui/material';
import { updateMetric, getMetricByName } from '../services/api';
import { useMsal } from "@azure/msal-react";
import errorMessageToDisplay from '../services/error';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DropdownField from './DropdownField';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Autocomplete from '@mui/material/Autocomplete';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const EditMetricDetail = (props) => {
    const { metric, open, setOpen, setEdit, metrics, setMetrics, setIsLoading, setErrorMessage, unitValueTypes, sourceFields } = props;
    const { instance } = useMsal();
    const [metricCopy, setMetricCopy] = useState({...metric});
    const [nameIsValid, setNameIsValid] = useState(true);
    const [displayNameIsValid, setDisplayNameIsValid] = useState(true);
    const [positionAndCompanyLevelNameIsValid, setPositionAndCompanyLevelNameIsValid] = useState(true);
    const [valueUnitSourceIsValid, setValueUnitSourceIsValid] = useState(true);
    const [metricSourceFieldsForProductSuite, setMetricSourceFieldsForProductSuite] = useState([]);
    const [metricValueTypes, setMetricValueTypes] = useState([]);
    const [newValueUnitSource, setNewValueUnitSource] = useState(false);
    const [selectedMetricSourceField, setSelectedMetricSourceField] = useState(null);
    
    const errorText = 'Field cannot be empty';
    const [nameError, setNameError] = useState('');
    const [displayNameError, setDisplayNameError] = useState('');
    const [positionAndCompanyLevelNameError, setPositionAndCompanyLevelNameError] = useState('');
    const [valueUnitTypeError, setValueUnitTypeError] = useState('');
    const [selectedMetricSourceFieldError, setSelectedMetricSourceFieldError] = useState('');

    const getSourcesToDisplay = (sourceProductSuite) => {
      if(sourceProductSuite == null || sourceProductSuite.trim() === '') {
        sourceProductSuite = sourceFields[0].sourceProductSuite;
      }
      const filteredItems = sourceFields.filter((item) => item.sourceProductSuite === sourceProductSuite);
      return filteredItems;
    }

    useEffect(() => {
      let filteredSourceFields = getSourcesToDisplay(metric.sourceProductSuite);
      setMetricSourceFieldsForProductSuite(filteredSourceFields.length > 0 ? filteredSourceFields[0].sourceFields : []);
      setMetricValueTypes(filteredSourceFields.length > 0 ? filteredSourceFields[0].metricValueTypes : []);
    }, []);

    useEffect(() => {
      let selectedSourceField =  metricSourceFieldsForProductSuite.find(field => field.metricTypeCode === metricCopy.sourceDataProductMetricTypeCode && field.metricCurrency === metricCopy.metricCurrency && field.metricCarveout === metricCopy.metricCarveout);
      setSelectedMetricSourceField(selectedSourceField);
    }, [metricSourceFieldsForProductSuite]);

    function mapTypesToOptions(types) {
      const options = Array.isArray(types)
        ? types.filter(type => type != null).map(type => ({
            label: type.label || String(type),
            value: type.value ?? type,
          }))
        : [];

      return options;
    }

    const handleFieldChange = (selectedValue, field) => {
      console.log('handleFieldChange', field, selectedValue);
      if(field === 'name' && nameIsValid === false) {
        setNameIsValid(true);
        setNameError('');
      }
      else if(field === 'displayName' && displayNameIsValid === false) {
        setDisplayNameIsValid(true);
        setDisplayNameError('');
      }
      else if(field === 'positionAndCompanyLevelName' && positionAndCompanyLevelNameError === false) {
        setPositionAndCompanyLevelNameIsValid(true);
        setPositionAndCompanyLevelNameError('');
      }      
      else if(field === 'valueUnitType' && valueUnitSourceIsValid === false) {
        setValueUnitSourceIsValid(true);
        setValueUnitTypeError('');
      }
      else if(field === 'sourceProductSuite') {
        let filteredSourceFields = getSourcesToDisplay(selectedValue);
        setMetricSourceFieldsForProductSuite(filteredSourceFields.length > 0 ? filteredSourceFields[0].sourceFields : []);
        setMetricValueTypes(filteredSourceFields.length > 0 ? filteredSourceFields[0].metricValueTypes : []);
        metricCopy.valueUnitType = null;
        metricCopy.sourceDataProductMetricTypeCode = null;
        setSelectedMetricSourceField(null);
      }
      else if(field === 'sourceDataProductMetricTypeCode') {
        let selectedSourceField = selectedValue;
        setSelectedMetricSourceField(selectedSourceField);
        setSelectedMetricSourceFieldError('');
        setValueUnitSourceIsValid(true);
        setValueUnitTypeError('');
        metricCopy.valueUnitType = selectedSourceField ? selectedSourceField.metricUnit : null;
        metricCopy.metricCurrency = selectedSourceField ? selectedSourceField.metricCurrency : null;
        metricCopy.metricCarveout = selectedSourceField ? selectedSourceField.metricCarveout : null;
      }
      else if(field === 'positionAndCompanyLevelName') {
        setPositionAndCompanyLevelNameIsValid(true);
        setPositionAndCompanyLevelNameError('');
      }

      metricCopy[field] =  field ==="sourceDataProductMetricTypeCode" ? selectedValue ? selectedValue.metricTypeCode : null : selectedValue;
      setMetricCopy({
          ...metricCopy
      });
      console.log(metricCopy);
    }

    const fieldsAreValid = () => {
      let fieldsAreValid = true;
      if(metricCopy.name == null || metricCopy.name.trim() === '') {
        setNameIsValid(false);
        setNameError(errorText);
        fieldsAreValid = false;
      }
      if(metricCopy.displayName == null || metricCopy.displayName.trim() === '') {
        setDisplayNameIsValid(false);
        setDisplayNameError(errorText);
        fieldsAreValid = false;
      }
      if(metricCopy.valueUnitType == null || metricCopy.valueUnitType.trim() === '') {
        setValueUnitSourceIsValid(false);
        setValueUnitTypeError(errorText);        
        fieldsAreValid = false;
      }
      if(metricCopy.positionAndCompanyLevelName == null || metricCopy.positionAndCompanyLevelName.trim() === '') {
        setPositionAndCompanyLevelNameIsValid(false);
        setPositionAndCompanyLevelNameError(errorText);
        fieldsAreValid = false;
      }
      if(metricCopy.sourceDataProductMetricTypeCode == null || metricCopy.sourceDataProductMetricTypeCode.trim() === '') {
        setSelectedMetricSourceFieldError(errorText);
      }
      
      return fieldsAreValid;
    }

    const handleSave = () => {
      console.log(metricCopy);
      if(!fieldsAreValid()) {
        console.log('Fields are not valid');
        return;
      }
      
      if(metric.name !== metricCopy.name) {
        getMetricByName(metricCopy.name)
        .then((response) => {
          if(response.metricExists != null && response.metricExists === false) {
            setIsLoading(true);
            updateMetric(metricCopy, instance.getActiveAccount().username)
            .then(() => {
              setIsLoading(false);
              var metricIndex = metrics.findIndex((obj => obj.id === metric.id));
              metrics[metricIndex] = metricCopy;
              setMetrics([...metrics]);
              setEdit(false);
              setOpen(false);
            })
            .catch((e) => {
              setIsLoading(false);
              console.log(e)
              setErrorMessage(errorMessageToDisplay);
            })   
          }
          else {          
            setNameIsValid(false);
            setNameError('Metric name already exists');
            return;          
          }
        })
        .catch((e) => {
          setIsLoading(false);
          console.log(e)
          setErrorMessage(errorMessageToDisplay);
        })    
      }
      else {
        setIsLoading(true);
        updateMetric(metricCopy, instance.getActiveAccount().username)
        .then(() => {
          setIsLoading(false);
          var metricIndex = metrics.findIndex((obj => obj.id === metric.id));
          metrics[metricIndex] = metricCopy;
          setMetrics([...metrics]);
          setEdit(false);
          setOpen(false);
        })
        .catch((e) => {
          setIsLoading(false);
          console.log(e)
          setErrorMessage(errorMessageToDisplay);
        })    
      }   
    }
  
    const handleClose = () => {
      setEdit(false);
      setOpen(true);
    }

    const sourceProductSuitesToDisplay = (sourceFields) => {
      return sourceFields.map((sourceField) => sourceField.sourceProductSuite);
    }

    const handleNewValueUnitClick = () => {
      setNewValueUnitSource(true);
    };
  
    const handleExistingValueUnitClick = () => {
      setNewValueUnitSource(false);
    };
    
    return (
      <>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
          maxWidth="lg"
        >
          <DialogTitle>{"Metric Detail"}</DialogTitle>
          <DialogContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={3}><label><b>Name:</b></label></Grid>
                <Grid item xs={11} sm={8}><TextField inputProps={{ maxLength: 250 }} required value={metricCopy.name} error={!nameIsValid} helperText={nameError} fullWidth onChange={(event) => handleFieldChange(event.target.value, 'name')}/></Grid>
                <Grid item xs={1} sm={1}>
                  <Tooltip
                    title={
                      <div>
                        <p>
                          This is an internal name for the metric, it should be unique and descriptive. This is not to be be used for any reporting purposes.
                        </p>
                      </div>
                    }
                    leaveDelay={200}
                  >
                    <IconButton tabIndex={-1} edge="end">
                      <InfoOutlinedIcon color="primary" sx={{ fontSize: '1.3rem' }} />
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item xs={12} sm={3}><label><b>Display Name:</b></label></Grid>
                <Grid item xs={11} sm={8}><TextField inputProps={{ maxLength: 250 }} required value={metricCopy.displayName} error={!displayNameIsValid} helperText={displayNameError} fullWidth onChange={(event) => handleFieldChange(event.target.value, 'displayName')}/></Grid>
                <Grid item xs={1} sm={1}>
                  <Tooltip
                    title={
                      <div>
                        <p>
                          This is a <b>required field</b>, and is often used in regulatory reporting, so <b>please ensure it is accurate, and in line with other reporting requirements.</b>
                        </p>
                        <p>
                          At the fund/entity level, some ESG metrics (e.g., <b>WACI</b> - Weighted Average Carbon Intensity) may have different names or calculations at the position & company level (e.g., <b>Scope 1 Emissions</b>), as fund-level data is typically rolled up and weighted from the underlying positions.
                        </p>
                      </div>
                    }
                    leaveDelay={200}
                  >
                    <IconButton tabIndex={-1} edge="end">
                      <InfoOutlinedIcon color="primary" sx={{ fontSize: '1.3rem' }} />
                    </IconButton>
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={3}><label><b>Position & Company Level Name:</b></label></Grid>
                <Grid item xs={11} sm={8}><TextField inputProps={{ maxLength: 250 }} required value={metricCopy.positionAndCompanyLevelName} error={!positionAndCompanyLevelNameIsValid} helperText={positionAndCompanyLevelNameError} fullWidth onChange={(event) => handleFieldChange(event.target.value, 'positionAndCompanyLevelName')}/></Grid>
                <Grid item xs={1} sm={1}>
                  <Tooltip
                    title={
                      <div>
                        <p>
                          At the position level, some ESG metrics (e.g., <b>Scope 1 Emissions</b>) may have different names or calculations at the rolled up fund/entity level (e.g., <b>WACI</b> - Weighted Average Carbon Intensity), as fund-level data is typically rolled up and weighted from the underlying positions.
                        </p>
                        <p>
                          This is a <b>required field</b>, please make it the same as <b>Display Name</b> if the name does not differ at position & company level.
                        </p>
                      </div>
                    }
                    leaveDelay={200}
                  >
                    <IconButton tabIndex={-1} edge="end">
                      <InfoOutlinedIcon color="primary" sx={{ fontSize: '1.3rem' }} />
                    </IconButton>
                  </Tooltip>

                  </Grid>
                    <Grid item xs={12} sm={3}><label><b>Metric Description:</b></label></Grid>
                    <Grid item xs={11} sm={8}>
                      <TextField
                          required
                          value={metricCopy.metricDescription || ''}
                          fullWidth
                          onChange={(event) => handleFieldChange(event.target.value, 'metricDescription')}
                          multiline
                          minRows={2}
                          maxRows={6}
                          inputProps={{ maxLength: 1000 }}
                       />
                    </Grid>
                    <Grid item xs={1} sm={1}>
                      <Tooltip
                        title="A useful description and any relevant information to this metric. This is not presently required."
                        leaveDelay={200}
                      >
                        <IconButton tabIndex={-1} edge="end">
                          <InfoOutlinedIcon color="primary" sx={{ fontSize: '1.3rem' }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                <br/>
                <br/>
                <br/>
                <Grid item sm={12}>
                  <h4>Source Fields</h4>
                </Grid>
                  <Grid item xs={12} sm={3}><label><b>Source Product Suite:</b></label></Grid>
                  <Grid item xs={11} sm={8}>
                    <DropdownField
                      options={mapTypesToOptions(sourceProductSuitesToDisplay(sourceFields))}
                      value={metricCopy.sourceProductSuite || ''}
                      onChange={(event) => handleFieldChange(event.target.value, 'sourceProductSuite')}
                    />
                  </Grid>
                  <Grid item xs={1} sm={1}/>

                  <Grid item xs={12} sm={3}><label><b>Metric Source Field:</b></label></Grid>
                  <Grid item xs={11} sm={8}>
                    <FormControl fullWidth >
                      <Autocomplete
                        id="source-field.select"
                        required
                        options={metricSourceFieldsForProductSuite}
                        value={selectedMetricSourceField || null}
                        autoHighlight
                        getOptionLabel={(option) => option.metricTypeCode + (option.metricCarveout ? ', Carve-out: ' + option.metricCarveout : '') + (option.metricCurrency ? ', Currency: ' + option.metricCurrency : '')}
                        onChange={(event, newValue) => {
                           handleFieldChange(newValue, 'sourceDataProductMetricTypeCode');
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={!!selectedMetricSourceFieldError}
                            helperText={selectedMetricSourceFieldError ? 'Please select a metric source field' : ''}
                            inputProps={{
                                ...params.inputProps
                              , maxLength: 200
                            }}
                          />
                        )}
                      />                          
                    </FormControl>      
                  </Grid>
                  <Grid item xs={1} sm={1}/>

                  <Grid item xs={12} sm={3}><label><b>Metric Value Type:</b></label></Grid>
                  <Grid item xs={11} sm={8}>
                    <DropdownField
                      options={mapTypesToOptions(metricValueTypes)}
                      value={metricCopy.metricValueType || ''}
                      onChange={(event) => handleFieldChange(event.target.value, 'metricValueType')}
                    />
                  </Grid>
                <Grid item xs={1} sm={1}>
                  <Tooltip
                    leaveDelay={200}
                    title=
                      {
                        <>
                          <span>M&G have two available values when calculating fund/entity metric values from the underlying holdings metrics:</span>
                          <ol>
                            <li><strong>Absolute</strong> - based on the assets in scope "carveout" for numerator and denominator. Includes all in scope holdings even when metric value not available i.e. impacts denominator but no numerator.</li>
                            <li><strong>Normalised</strong> - based only on the assets in scope "carveout" that have metrics value. i.e. reweighted/reduction in the denominator. Equivalent to all positions with no metric assumed to have the average value.</li>
                          </ol>
                        </>
                      }
                  >
                    <IconButton tabIndex={-1} edge="end">
                      <InfoOutlinedIcon color="primary" sx={{ fontSize: '1.3rem' }} />
                    </IconButton>
                  </Tooltip>
                </Grid>
                {selectedMetricSourceField && selectedMetricSourceField.metricUnit ?
                <>
                      <Grid item xs={12} sm={3}><label><b>Currency:</b></label></Grid>
                      <Grid item xs={11} sm={8}>
                          <TextField value={selectedMetricSourceField.metricCurrency} fullWidth readOnly disabled/>
                      </Grid>
                      <Grid item xs={1} sm={1}>
                        <Tooltip
                          title="The Metric Currency is set automatically from the source ESG data for this metric. This is for reference purposes only. Currency is not applicable for all metrics, so it may be blank."
                          leaveDelay={200}
                        >
                          <IconButton tabIndex={-1} edge="end">
                            <InfoOutlinedIcon color="primary" sx={{ fontSize: '1.3rem' }} />
                          </IconButton>
                        </Tooltip>
                      </Grid>    

                      <Grid item xs={12} sm={3}><label><b>Value Unit Type:</b></label></Grid>
                      <Grid item xs={11} sm={8}>
                          <TextField value={selectedMetricSourceField.metricUnit} fullWidth readOnly disabled/>
                      </Grid>
                      <Grid item xs={1} sm={1}>
                        <Tooltip
                          title="The Metric Unit is set automatically from the source ESG data for this metric. This is for reference purposes only."
                          leaveDelay={200}
                        >
                          <IconButton tabIndex={-1} edge="end">
                            <InfoOutlinedIcon color="primary" sx={{ fontSize: '1.3rem' }} />
                          </IconButton>
                        </Tooltip>
                      </Grid>

                      <Grid item xs={12} sm={3}><label><b>Metric Carve-out:</b></label></Grid>
                      <Grid item xs={11} sm={8}>
                          <TextField value={selectedMetricSourceField.metricCarveout} fullWidth readOnly disabled/>
                      </Grid>
                      <Grid item xs={1} sm={1}>
                        <Tooltip
                          title="The Metric Carve-out is set automatically from the source ESG data for this metric. This is for reference purposes only. Metric-carveout defines the scope of the metrics, i.e. which positions are included in the metric calculation."
                          leaveDelay={200}
                        >
                          <IconButton tabIndex={-1} edge="end">
                            <InfoOutlinedIcon color="primary" sx={{ fontSize: '1.3rem' }} />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                </>
                :
                  newValueUnitSource === true ?
                    <>
                      <Grid item xs={12} sm={3}><label><b>Value Unit Type:</b></label> <br/>                  
                        <Link href="#" onClick={handleExistingValueUnitClick} style={{ textAlign: 'center', alignSelf: 'flex-end' }}>
                          Existing
                        </Link>                
                      </Grid>  
                      <Grid item xs={11} sm={8}><TextField inputProps={{ maxLength: 200 }} required value={metricCopy.valueUnitType} error={!valueUnitSourceIsValid} helperText={valueUnitTypeError} onChange={(event) => handleFieldChange(event.target.value, 'valueUnitType')} /></Grid>
                      <Grid item xs={1} sm={1}/>
                    </>
                  :
                    <>
                      <Grid item xs={12} sm={3}><label><b>Value Unit Type:</b></label> <br/>                  
                        <Link href="#" onClick={handleNewValueUnitClick} style={{ textAlign: 'center', alignSelf: 'flex-end' }}>
                          New
                        </Link>  
                      </Grid>
                      <Grid item xs={11} sm={8}><DropdownField options={mapTypesToOptions(unitValueTypes)} value={metricCopy.valueUnitType || ''} onChange={(event) => handleFieldChange(event.target.value, 'valueUnitType')} /></Grid>
                      <Grid item xs={1} sm={1}/>
                    </>
                }
              </Grid>
          </DialogContent>
          <DialogActions>
              <Button onClick={handleSave}>Save</Button>
              <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>                    
        </Dialog>
      </>
    );
  };

  export default EditMetricDetail;

